import {
  Stack,
  TextField,
  Typography,
  Box,
  Button,
  Radio,
} from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { useFormikContext } from "formik";

const USE_CASES = [
  {
    value: "home",
    label: "Home Charging",
    description: "Personal home charging",
    icon: HomeOutlinedIcon,
  },
  {
    value: "business",
    label: "Business / Fleet",
    description: "Professional charging management",
    icon: ApartmentOutlinedIcon,
  },
];

export default function AboutYouStep({ onNext, onBackToLogin }) {
  const { values, errors, touched, getFieldProps, setFieldValue } =
    useFormikContext();

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h6" fontWeight={600}>
          About You
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Tell us about yourself
        </Typography>
      </Box>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          fullWidth
          required
          label="First Name"
          placeholder="John"
          {...getFieldProps("firstName")}
          error={Boolean(touched.firstName && errors.firstName)}
          helperText={touched.firstName && errors.firstName}
        />
        <TextField
          fullWidth
          required
          label="Last Name"
          placeholder="Doe"
          {...getFieldProps("lastName")}
          error={Boolean(touched.lastName && errors.lastName)}
          helperText={touched.lastName && errors.lastName}
        />
      </Stack>

      <TextField
        fullWidth
        required
        label="Email Address"
        placeholder="john@example.com"
        {...getFieldProps("email")}
        error={Boolean(touched.email && errors.email)}
        helperText={touched.email && errors.email}
      />

      <TextField
        fullWidth
        required
        label="Country"
        placeholder="India"
        {...getFieldProps("country")}
        error={Boolean(touched.country && errors.country)}
        helperText={touched.country && errors.country}
      />

      <Box>
        <Typography variant="body2" fontWeight={600} sx={{ mb: 1.5 }}>
          How will you use Zynka? *
        </Typography>

        <Stack spacing={1.5}>
          {USE_CASES.map(({ value, label, description, icon: Icon }) => {
            const isSelected = values.useCase === value;
            return (
              <Box
                key={value}
                onClick={() => setFieldValue("useCase", value)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  p: 2,
                  borderRadius: "10px",
                  border: "1.5px solid",
                  borderColor: isSelected ? "primary.main" : "divider",
                  bgcolor: isSelected ? "action.selected" : "background.paper",
                  transition: "border-color 0.15s, background-color 0.15s",
                }}
              >
                <Radio
                  checked={isSelected}
                  size="small"
                  sx={{ p: 0 }}
                  onChange={() => setFieldValue("useCase", value)}
                />
                <Icon sx={{ color: "text.secondary" }} />
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    {label}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {description}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Stack>
        {touched.useCase && errors.useCase && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: "block", mt: 0.5 }}
          >
            {errors.useCase}
          </Typography>
        )}
      </Box>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Button onClick={() => (window.location.href = "/login")} sx={{ color: "text.secondary" }}>
          Back to Login
        </Button>
        <Button variant="contained" onClick={onNext}>
          Continue
        </Button>
      </Stack>
    </Stack>
  );
}